import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DocumentSubFolderName } from "@models/common/document-sub-folder-name.enum";
import { FileCreateDto, FilesResponse } from "@models/ui-models/files";
import BaseApiService from "@shared/services/base/base-api.service";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class FilesApiService extends BaseApiService {
  getFiles(documentId: string): Observable<FilesResponse> {
    return this.api.get<FilesResponse>(`${ this.apiUrl }/files/${ documentId }`);
  }

  downloadFile(documentId: string, fileName: string, subFolderName: string): Observable<string> {
    const params = new HttpParams().set('fileName', fileName);
    return this.api.get<string>(`${ this.apiUrl }/files/${ documentId }/download/${ subFolderName }`, { params });
  }

  downloadFolder(documentId: string, asOnePdfFile: boolean, subFolderName: string): Observable<string> {
    const params = new HttpParams().set('asOnePdfFile', asOnePdfFile);
    return this.api.get<string>(`${ this.apiUrl }/files/${ documentId }/download-folder/${ subFolderName }`, { params });
  }

  downloadDocumentBulk(documentsId: string[]): Observable<string> {
    return this.api.post<string>(`${ this.apiUrl }/files/download/bulk`, documentsId);
  }

  uploadFile(documentId: string, body: FileCreateDto, subFolderName: string): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/files/${ documentId }/upload/${ subFolderName }`, body);
  }

  uploadFilesBulk(documentId: string, subfolder = DocumentSubFolderName.Upload, body: FileCreateDto[]): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/files/${ documentId }/upload/${ subfolder }/bulk`, body);
  }

  deleteFile(documentId: string, fileName: string, subfolder = DocumentSubFolderName.Upload): Observable<unknown> {
    const params = new HttpParams().set('fileName', fileName);
    return this.api.delete<void>(`${ this.apiUrl }/files/${ documentId }/${ subfolder }`, { params });
  }
}
